// extracted by mini-css-extract-plugin
module.exports = {"title":"ChildMobile_title__3o7hW","addMenber":"ChildMobile_addMenber__1RGo7","delete":"ChildMobile_delete__2ZTlg","childList":"ChildMobile_childList__35FZo"};